export const TERMS_OF_USE_UPDATE_MODAL_SLUG = 'update-terms-of-use-modal';

export const PROFILE_CONSENT_COOKIE_CONSENT_NAMES = {
  ccpaRequired: 'ccpaRequired',
  gdprRequired: 'gdprRequired',
  touRequired: 'touRequired',
} as const;

export const PROFILE_CONSENT_COOKIE_NAME = 'profileconsent';

export const TERMS_OF_USE_MODAL_TYPES = {
  updateModal: 'UPDATE_MODAL',
  acceptModal: 'ACCEPT_MODAL',
} as const;

/**
 * Query parameter used to indicate whether the Terms of Use acceptance modal should be shown.
 *
 * This parameter is typically used in URL queries to trigger the display of the Terms of Use acceptance flow.
 */
export const SHOW_TERMS_OF_USE_ACCEPT_PARAM = 'showTouAccept';

export const EXCLUDED_APP_NAMES = ['about'];
export const EXCLUDED_PATHS = /(about\/(terms|privacy))|account-settings/gi;

// Source: https://docs.google.com/spreadsheets/d/1jzeBOP0EdJm9k-WU3jSmv6TZyhtcI8o_IkhxlmwuCcw/edit?gid=1545870019#gid=1545870019
// The access needs to be restricted, reaching out to legal for the access.
export const LEGAL_MARKETING_CONSENT_MODAL_RESTRICTED_ENTERPRISES = [
  'wUnIXAWGSluh6nPgkk-U7Q',
  '_khIP87SRomhUydEliGbnw',
  'WpsN3G6xRGOAM_JokfF64g',
  'BuDYakZoRCygmgchZbvKWg',
  'z0BIUPMjQpC8nZ2AwTjvCw',
  'C5ZTs8KzR0eS8ePEYazlOw',
  'Bs7e4CK9QgaElyD8RGbERQ',
  'pH4h-SgQRsKQt37rOx1UWg',
  'uBcqWQWoTXGAkR0J-e3Dpg',
  'dbiBuSR5QBGLeGsS7qC6ow',
  'j8gFFNSFSqirvsWEdUhpGw',
  'Lt0Kj04fQJuJ2xjOTLNwWQ',
];

export default {
  TERMS_OF_USE_UPDATE_MODAL_SLUG,
  TERMS_OF_USE_MODAL_TYPES,
  PROFILE_CONSENT_COOKIE_CONSENT_NAMES,
  PROFILE_CONSENT_COOKIE_NAME,
  SHOW_TERMS_OF_USE_ACCEPT_PARAM,
  EXCLUDED_APP_NAMES,
  EXCLUDED_PATHS,
};
